import React from "react";
import { NavLink } from "react-router-dom";
import "./admin-dashboard.css";

export default function Sidebar() {
  const link = ({ isActive }) => isActive ? "adm-active" : "";
  return (
    <aside className="adm-sidebar">
      <div className="adm-brand">Suvidha Admin</div>

      <nav className="adm-nav">
        <NavLink to="/admin/dashboard"        className={link}><span>🏠</span><span>Dashboard</span></NavLink>
        <NavLink to="/admin/users"            className={link}><span>👥</span><span>Users</span></NavLink>
        <NavLink to="/admin/subscriptions"    className={link}><span>💳</span><span>Subscriptions</span></NavLink>
        <NavLink to="/admin/revenue"          className={link}><span>📊</span><span>Revenue</span></NavLink>
        <NavLink to="/admin/reports"          className={link}><span>🧾</span><span>Reports</span></NavLink>
        <NavLink to="/admin/bookings"         className={link}><span>📋</span><span>Service Bookings</span></NavLink>
        <NavLink to="/admin/service-analytics"className={link}><span>📈</span><span>Service Analytics</span></NavLink>
        {/* <NavLink to="/admin/feedback"         className={link}><span>⭐</span><span>Feedback</span></NavLink> */}
        <NavLink to="/admin/contacts"         className={link}><span>📬</span><span>Enquiries</span></NavLink>
      </nav>

      <div className="adm-sidebar-footer">
        <div style={{ fontWeight:800 }}>Suvidha</div>
        <div style={{ opacity:0.9 }}>Admin Panel</div>
      </div>
    </aside>
  );
}
